import UpdateOrderInfoRequestModelBase from '../_generated/modelBases/update-order-info-request-model-base';

export default class UpdateOrderInfoRequestModel extends UpdateOrderInfoRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
